import { getCurrentMapUsers } from '@redux/memoizedSelectors';
import Mention from '@tiptap/extension-mention'
import { EMPTY_GUID } from '@utils/helpers';
import InitialsBubble from 'features/settings/manage-users/components/initials-bubble';
import { useSelector } from 'react-redux';
import { FlexAlignCenter } from 'shared/ui-basics';

export const AddMentionConfig = ({ setPortalContent, setMentionElement }) => {
  const users = useSelector(getCurrentMapUsers).filter(u => u.roleId !== EMPTY_GUID)?.map((user) => {
    return { id: user.id, value: user.fullName };
  })

  if (!setMentionElement) {
    return []
  }
  return Mention.configure({
    HTMLAttributes: {
      class: 'mention',
    },
    suggestion: {
      char: '@',
      items: ({ query }) => {
        return users.filter(user => user.value?.toLowerCase().startsWith(query?.toLowerCase()));
      },
      render: () => {
        let popup = null;
        return {
          onStart: props => {

            const { clientRect, items, command } = props;
            const popUpHeight = items.length > 5 ? 200 :  items.length * 40;
            popup = (
              <ul style={{
                position: 'absolute',
                top: `${clientRect().top - clientRect().height - (popUpHeight)}px`,
                left: `${clientRect().left}px`,
                zIndex: 1100 // Ensure it's above other content
              }} className='mention-suggestions'>
                {items.map((item, i) => (
                  <li key={item.id}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      command({ id: item.value });
                      setMentionElement((prevState) => [...prevState || [], item]);
                    }}>
                    <FlexAlignCenter>
                      <InitialsBubble fullName={item.value} size='xs' />
                      <span className='ms-1'>{item.value}</span>
                    </FlexAlignCenter>

                  </li>
                ))}
              </ul>
            );

            // Set the content to be rendered in the portal
            setPortalContent(popup);
            // Trigger a re-render
          },
          onUpdate(props) {
            const { clientRect, items, command } = props;
            popup = <ul style={{
              position: 'absolute',
              top: `${clientRect().top + clientRect().height}px`,
              left: `${clientRect().left}px`,
              zIndex: 1100,
            }} className='mention-suggestions'>
              {items.map((item, i) => (
                <li key={item.id}
                  onClick={() => {
                    command({ id: item.value });
                    setMentionElement((prevState) => [...prevState || [], item]);
                  }}>
                  <FlexAlignCenter>
                    <InitialsBubble fullName={item.value} size='xs' />
                    <span className='ms-1'>{item.value}</span>
                  </FlexAlignCenter>
                </li>
              ))}
            </ul>;

            // Update the component
            setPortalContent(popup);
          },
          onExit() {
            setPortalContent(null); // Clear the portal content when not needed
          },

        };
      }
    }
  })

}